import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  public pageType: string = ""

  constructor() {}

  ngOnInit() {
    let url = window.location.href.toUpperCase();

    if(url.includes("/Account/VerifyPhone".toUpperCase()) ||
      url.includes("/Account/Login".toUpperCase())) {
      this.pageType = "phone-verification";
    }
    else if(url.includes("/Home/LeaderboardEmbed".toUpperCase())) {
      this.pageType = "leaderboard-embed";
    }
    else if(url.includes("/Home/RegisterParent".toUpperCase())) {
      this.pageType = "register-parent";
    }
    else if(url.includes("/Home/Register".toUpperCase())) {
      this.pageType = "register";
    }
  }
}
